import { render, staticRenderFns } from "./EditAssignedUser.vue?vue&type=template&id=c97f0d48&lang=pug"
import script from "./EditAssignedUser.vue?vue&type=script&lang=js"
export * from "./EditAssignedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports